import Icon from '@ant-design/icons';
import * as React from 'react';

const ErrorIcon2Svg = (props) => {
    return (
<svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
<path fill-rule="evenodd" clip-rule="evenodd" d="M0 7C0 3.13359 3.13359 0 7 0C10.8664 0 14 3.13359 14 7C14 10.8664 10.8664 14 7 14C3.13359 14 0 10.8664 0 7ZM9.80547 9.81367C9.99824 9.62227 9.99824 9.31055 9.80684 9.11777L7.69453 7L9.80684 4.88086C9.99824 4.68809 9.99824 4.37637 9.80547 4.18496C9.6127 3.99355 9.30098 3.99355 9.10957 4.18633L7 6.30273L4.89043 4.1877C4.69902 3.99492 4.3873 3.99492 4.19453 4.18633C4.00176 4.37773 4.00176 4.68945 4.19316 4.88223L6.30547 7L4.19316 9.11777C4.00176 9.31055 4.00176 9.62227 4.19453 9.81367C4.29023 9.90938 4.41602 9.95723 4.5418 9.95723C4.66758 9.95723 4.79473 9.90938 4.89043 9.8123L7 7.69727L9.10957 9.8123C9.20527 9.90938 9.33242 9.95723 9.4582 9.95723C9.58398 9.95723 9.70977 9.90938 9.80547 9.81367Z" fill="#DA1E28"/>
</svg>
    );
};

export const ErrorIcon2 = props => (
    <Icon component={ErrorIcon2Svg} {...props} />
);
